/**
 * A role that can be assigned to an employee in a rota.
 */
export enum RotaRole {
  /** A person is assigned to keep the key to the store for opening and closing. */
  KEYHOLDER = 'KEYHOLDER',

  /** A person is assigned to perform banking procedures. */
  BANKING = 'BANKING',

  /** A person is assigned to perform a changeover. */
  CHANGEOVER = 'CHANGEOVER',

  /** A person is assigned to do sales. */
  SALESPERSON = 'SALESPERSON',

  /** A person is assigned to coordinate the opening of the store. */
  SHOP_OPENER = 'SHOP_OPENER',

  /** A person is assigned to coordinate the closing of the store. */
  SHOP_CLOSER = 'SHOP_CLOSER',

  /** A person is assigned to manage a changeover. */
  CHANGEOVER_MANAGER = 'CHANGEOVER_MANAGER'
}

/**
 * Roles who are shown in daily and weekly rota pages. All other roles are not displayed.
 */
export function visibleRoles(): Array<RotaRole> {
  return [RotaRole.BANKING, RotaRole.CHANGEOVER, RotaRole.KEYHOLDER];
}
